const classes = {
  root: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: 'rgba(0,0,0,.035)',
  },
  toolbar: {
    height: '20px',
  },
  contentMobile: {
    flexGrow: '1',
    width: '100%',
  },
  content: {
    flexGrow: '1',
    width: '100%',
  },
};

export default classes;
